{
  "nl": {
    "reminder": {
      "actions": {
        "cancel": "Annuleer",
        "edit": "Bewerken",
        "hideReminders": "Verberg herinneringen",
        "save": "Sla op",
        "showReminders": "Toon herinneringen"
      },
      "contactType": {
        "customer": "Klant",
        "partner": "partner"
      },
      "labels": {
        "after": "na",
        "before": "voor",
        "click": "Klik hier om een herinnering in te stellen",
        "date": "op {date}",
        "dateAfterDueDate": "Na deadline",
        "dateAlreadyPassed": "datum is al voorbij",
        "decisionApprovedNotSent": "De beslissing is genomen. Herinneringen die nog in de wachtrij stonden werden geannuleerd.",
        "dueDate": "de deadline",
        "editTitle": "Herinneringen bewerken",
        "here": "hier",
        "infoReminders": "Herinneringen zijn alleen actief voor termijnen waarvoor een deadline is ingesteld.",
        "noReminderSet": "Geen herinnering ingesteld",
        "reminder": "Herinnering",
        "reminders": "Herinneringen",
        "remindersCustomer": "Herinneringen voor de klant",
        "remindersPartners": "Herinneringen voor de partner(s)",
        "sendOnDeadline": "Herinnering zal gestuurd worden op de dag van de deadline",
        "sendReminder": "Stuur herinnering",
        "sent_at": "Herinnering verzonden op {date}",
        "warningReminders": "Deze actie vervangt alle 4 herinneringen. Elke herinnering die hier leeg blijft, wordt voor elke beslissing verwijderd."
      },
      "toasts": {
        "update": "Herinnering succesvol bijgewerkt"
      }
    }
  }
}